"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EditableInteractionComponent = _interopRequireDefault(require("../../wrappers/EditableInteractionComponent"));

var _NoteComponent = _interopRequireDefault(require("./NoteComponent"));

var _default = (0, _EditableInteractionComponent.default)(_NoteComponent.default);

exports.default = _default;
module.exports = exports.default;